import requests from './Setup'
import { API_URL } from 'config/env'

const RESOURCE = `/WithHoldings`

const Withholding = {
  add: data =>
    requests.post(`${API_URL}${RESOURCE}`, data).then(response => {
      if (response && response.status === 201) return response.data
    }),
  getAll: (initial, take) =>
    requests.get(`${API_URL}${RESOURCE}/Get/${initial}/${take}`).then(response => response.data),
  getByDate: (from, to, initial, take) =>
    requests.get(`${API_URL}${RESOURCE}/GetByDate/${from}/${to}/${initial}/${take}`).then(response => response.data),
  getById: id =>
    requests.get(`${API_URL}${RESOURCE}/${id}`).then(response => response.data),
  update: (id, data) =>
    requests.put(`${API_URL}${RESOURCE}/${id}`, data).then(response => response.data),
  remove: id =>
    requests.del(`${API_URL}${RESOURCE}/${id}`).then(response => response.data),
  releaseInvoice: (id, invoiceId) =>
    requests.post(`${API_URL}${RESOURCE}/${id}/ReleaseInvoice/${invoiceId}`).then(response => response.data),
  getGeneratedTxts: (from, to) =>
    requests.get(`${API_URL}${RESOURCE}/GetWithholdingTxtGenerate/${from}/${to}`).then(response => response.data),
  getLastTxtGenerateDate: () =>
    requests.get(`${API_URL}${RESOURCE}/LastTxtGenerateDate`).then(response => response.data),
  getPendingForTxt: txtDate =>
    requests.get(`${API_URL}${RESOURCE}/PendingForTxt/${txtDate}`).then(response => response.data),
  exportTxt: txtDate =>
    requests.post(
      `${API_URL}${RESOURCE}/ExportWithholdingTxt`,
      { TxtDate: txtDate },
      { responseType: 'blob' }
    ).then(response => {
      if (response && response.status === 200) return response.data
    }),
  downloadTxt: generateNumber =>
    requests.get(
      `${API_URL}${RESOURCE}/DownloadWithholdingTxt/${generateNumber}`,
      { responseType: 'blob' }
    ).then(response => {
      if (response && response.status === 200) return response.data
    }),
}

export default Withholding
